import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.413A1.93 1.93 0 0 1 5 3h6a.97.97 0 0 1 .713.288Q12 3.575 12 4c0 .425-.096.52-.287.713A.97.97 0 0 1 11 5H5v14h6a.97.97 0 0 1 .713.288Q12 19.575 12 20c0 .425-.096.52-.287.712A.97.97 0 0 1 11 21zm12.175-8H10a.97.97 0 0 1-.713-.287A.97.97 0 0 1 9 12q0-.424.287-.713A.97.97 0 0 1 10 11h7.175L15.3 9.125a.92.92 0 0 1-.275-.675q0-.4.275-.7a.95.95 0 0 1 .7-.313.95.95 0 0 1 .725.288L20.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575a.93.93 0 0 1-.713.288 1.02 1.02 0 0 1-.712-.313.97.97 0 0 1-.263-.713.98.98 0 0 1 .288-.687z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }